module.exports = __webpack_public_path__ + "static/media/deflag.7f899b40.svg";